import { ProfilePrice } from './ProfilePrice'
import { useState } from 'react'
import { MdInfo } from 'react-icons/md'

type ProfilePriceContainerProps = {
  hourlyRate: number
}

export function ProfilePriceContainer({
  hourlyRate,
}: ProfilePriceContainerProps) {
  const [showCostPopup, setShowCostPopup] = useState(false)

  if (hourlyRate == null || hourlyRate == 0) return null

  return (
    <div className='relative flex ml-8 items-center gap-1'>
      <ProfilePrice hourlyRate={hourlyRate} className='mt-2' />
      <MdInfo
        className='-mt-2 h-[12px] w-[12px] md:-mt-4'
        color='#001A3D'
        onMouseEnter={() => setShowCostPopup(true)}
        onMouseLeave={() => setShowCostPopup(false)}
      />
      {showCostPopup && (
        <div className='absolute right-[-50px] top-[20px] bg-[#001A3D] text-white text-xs rounded-lg p-4 shadow-lg w-[250px] border border-[#EBFBFF] z-10'>
          <p>
            Average cost per hour, excluding VAT. Check with your lawyer to
            confirm their charges.
          </p>
        </div>
      )}
    </div>
  )
}
